// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceDisplay_price__ohoUZ","price__current":"PriceDisplay_price__current__MRdtB","price__note":"PriceDisplay_price__note__rNadS"};